// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header-panel {
    /* z-index: 9999 !important; */
    background-color: var(--headerBackground);
    color: var(--headerColor);
    position: fixed;
    top: 0px;
    left: 0px;
    height: 36px;
    width: 100%;
    text-align: center;
    line-height: 36px;
    border-bottom: 1px solid var(--headerBorder);
}

.work-panel {
    position: absolute;
    top: 37px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: var(--workPanelBackground);
}

.container {
    display: flex;
    flex-direction: column;
    min-width: 300px;
    position: absolute;
    bottom: 0px;
    top: 0px;
    left:0px;
    right:0px;
}

.mat-table {
    overflow: auto;
    /* min-width: 1560px; */
}
  
.mat-row {
    min-height: 40px;
    height: 43px;
}

.mat-cell {
    font-size: 13px;
}

.mat-header-row {
    top: 0;
    position: sticky;
    z-index: 1;
}


.mat-header-cell {
    font-size: 15px;
}

.mat-column-select {
    overflow: visible;
    flex: 0 0 100px;
}

.mat-column-username {
    flex: 0 0 200px;
}

.mat-column-fullname {
    flex: 2 1 250px;
}

.mat-column-groups {
    flex: 2 1 650px;
}

.mat-column-start {
    flex: 2 1 250px;
}

.mat-column-remove {
    flex: 0 0 60px;
}

.selectidthClass{
    flex: 0 0 50px;
 }

.show-password {
    bottom: 2px;
    right: 8px;
    position: absolute;
}

.my-header-filter ::ng-deep .mat-sort-header-button {
    display: block;
    text-align: left;
    margin-top: 5px;
}

.my-header-filter ::ng-deep .mat-sort-header-arrow {
    top: -12px;
    right: 20px;
}

.my-header-filter-input {
    display: block; 
    margin-top: 4px;
    margin-bottom: 6px;
    padding: 3px 1px 3px 2px;
    border-radius: 2px;
}`, "",{"version":3,"sources":["webpack://./src/app/users/users.component.css"],"names":[],"mappings":"AAAA;IACI,8BAA8B;IAC9B,yCAAyC;IACzC,yBAAyB;IACzB,eAAe;IACf,QAAQ;IACR,SAAS;IACT,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;AAChD;;AAEA;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,UAAU;IACV,WAAW;IACX,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;IACd,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,MAAM;IACN,gBAAgB;IAChB,UAAU;AACd;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;CACjB;;AAED;IACI,WAAW;IACX,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,wBAAwB;IACxB,kBAAkB;AACtB","sourcesContent":[".header-panel {\n    /* z-index: 9999 !important; */\n    background-color: var(--headerBackground);\n    color: var(--headerColor);\n    position: fixed;\n    top: 0px;\n    left: 0px;\n    height: 36px;\n    width: 100%;\n    text-align: center;\n    line-height: 36px;\n    border-bottom: 1px solid var(--headerBorder);\n}\n\n.work-panel {\n    position: absolute;\n    top: 37px;\n    left: 0px;\n    right: 0px;\n    bottom: 0px;\n    background-color: var(--workPanelBackground);\n}\n\n.container {\n    display: flex;\n    flex-direction: column;\n    min-width: 300px;\n    position: absolute;\n    bottom: 0px;\n    top: 0px;\n    left:0px;\n    right:0px;\n}\n\n.mat-table {\n    overflow: auto;\n    /* min-width: 1560px; */\n}\n  \n.mat-row {\n    min-height: 40px;\n    height: 43px;\n}\n\n.mat-cell {\n    font-size: 13px;\n}\n\n.mat-header-row {\n    top: 0;\n    position: sticky;\n    z-index: 1;\n}\n\n\n.mat-header-cell {\n    font-size: 15px;\n}\n\n.mat-column-select {\n    overflow: visible;\n    flex: 0 0 100px;\n}\n\n.mat-column-username {\n    flex: 0 0 200px;\n}\n\n.mat-column-fullname {\n    flex: 2 1 250px;\n}\n\n.mat-column-groups {\n    flex: 2 1 650px;\n}\n\n.mat-column-start {\n    flex: 2 1 250px;\n}\n\n.mat-column-remove {\n    flex: 0 0 60px;\n}\n\n.selectidthClass{\n    flex: 0 0 50px;\n }\n\n.show-password {\n    bottom: 2px;\n    right: 8px;\n    position: absolute;\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-button {\n    display: block;\n    text-align: left;\n    margin-top: 5px;\n}\n\n.my-header-filter ::ng-deep .mat-sort-header-arrow {\n    top: -12px;\n    right: 20px;\n}\n\n.my-header-filter-input {\n    display: block; \n    margin-top: 4px;\n    margin-bottom: 6px;\n    padding: 3px 1px 3px 2px;\n    border-radius: 2px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
